<script>
    // Stores 
	import { textSite } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';	
	
	let itensIcon = [
		{
			title: 'Mais de 45 anos de experiência.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Assessoria Jurídica especializada em Direito Imobiliário.',
            icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `Departamento Jurídico próprio.`,
		},
		{
			title: 'Cobrança Extrajudicial e Judicial de unidades.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Aqui você conversa direto com um colaborador que conhece seu Condomínio.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Solicita pagamentos, serviços e efetua consultas.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Pagamentos serão feitos somente com a autorização do Síndico, ou quem lhe represente.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Documentos do prédio, como Atas, comprovantes, Circulares, a disposição dos interessados.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Para maior comodidade, exercemos a função de Síndico Profissional.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Faça ou atualize a sua Convenção Condominial.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `Trata-se de um dos documentos mais importantes de um prédio, pois otimiza o cumprimento de regras específicas.`,
		},
		{
			title: 'DOC atualizado direto no site.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `Prefere receber automaticamente em seu e-mail, via disparo mensal? Sem problemas.`,
		},
		{
			title: 'Extrato de condomínio via site e APP. ',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `Sem despesas com cópias e com envio.`,
		},
		{
			title: 'Você pode solicitar Circulares, Advertências, Comunicações Gerais, restituições, aplicação de multa a morador maltoso',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `Trate dos assuntos cotidianos de seu Condomínio de forma eficaz e rápida.`,
		},
		{
			title: 'A melhor assessoria em Assembleias: ',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `Convocações, disponibilidade de realizar as reuniões na sede da Imobiliária, no prédio, ou por vídeo-chamada. Assessor Especializado em Direito Imobiliário e em questões condominiais. Ata revisada e disponibilizada em poucas horas.`,
		},
		{
			title: 'Auxílio à execução de decisões adotadas em Assembleias.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Apoio nos serviços periódicos de seu Condomínio',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `como recarga de extintores, limpeza de caixas d’água, inspeções de gás, instalações hidráulicas, elétricas, estruturais e outras.`,
		},
		{
			title: 'Orientação para elaboração de Laudos',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `por exemplo: PPCI, LTIP, Elétrico, Marquises, Sacadas, Fachadas (Estrutural).`,
		},
		{
			title: 'Departamento Jurídico altamente especializado.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: ` `,
		},
		{
			title: 'Os melhores e mais modernos Sistemas Operacionais à disposição.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `A Imobiliária Yara investe seriamente em tecnologia, de forma que nossos clientes tenham acesso às ferramentas mais eficazes do mercado.`,
		},
		{
			title: 'Plataforma digital.',
			icon: '<i class="fal fa-user-headset color-primary mb-20 fa-3x"></i>',
            text: `Seu Condomínio em seu telefone. Simples, completo e na hora!`,
		},
	];

</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container text-justify">
		<p>Administrar um condomínio é uma tarefa contínua, diária, que exige conhecimento técnico e ações precisas. Nossos Síndicos e Síndicas são recebidos com carinho e atenção na sede da empresa, local onde dúvidas são esclarecidas, e medidas são solicitadas, tais como, cobrança de condôminos inadimplentes, advertências, circulares, comunicações, convocação e assessoramento de assembleias, confecção de atas, e toda uma gama de serviços, cujo objetivo é atender amplamente os condomínios administrados.</p>
		<p>E para os clientes que preferem o atendimento online, solicitações são prontamente respondidas e atendidas por nosso Departamento de Condomínios.</p>
        <h2 class="title color-primary mt-35 mb-20 text-center">Diferenciais Imobiliária Yara</h2>
        <ul>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Mais de 45 anos de experiência.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Assessoria Jurídica especializada em Direito Imobiliário. Departamento Jurídico próprio.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Cobrança Extrajudicial e Judicial de unidades.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Aqui você conversa direto com um colaborador que conhece seu Condomínio.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Solicita pagamentos, serviços e efetua consultas.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Pagamentos serão feitos somente com a autorização do Síndico, ou quem lhe represente.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Documentos do prédio, como Atas, comprovantes, Circulares, a disposição dos interessados.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Para maior comodidade, exercemos a função de Síndico Profissional.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Faça ou atualize a sua Convenção Condominial. Trata-se de um dos documentos mais importantes de um prédio, pois otimiza o cumprimento de regras específicas.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                DOC atualizado direto no site. Prefere receber automaticamente em seu e-mail, via disparo mensal? Sem problemas.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Extrato de condomínio via site e APP. Sem despesas com cópias e com envio.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Você pode solicitar Circulares, Advertências, Comunicações Gerais, restituições, aplicação de multa a morador maltoso, trate dos assuntos cotidianos de seu Condomínio de forma eficaz e rápida.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                A melhor assessoria em Assembleias: Convocações, disponibilidade de realizar as reuniões na sede da Imobiliária, no prédio, ou por vídeo-chamada. Assessor Especializado em Direito Imobiliário e em questões condominiais. Ata revisada e disponibilizada em poucas horas.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Auxílio à execução de decisões adotadas em Assembleias.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Apoio nos serviços periódicos de seu Condomínio, como recarga de extintores, limpeza de caixas d’água, inspeções de gás, instalações hidráulicas, elétricas, estruturais e outras.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Orientação para elaboração de Laudos, por exemplo: PPCI, LTIP, Elétrico, Marquises, Sacadas, Fachadas (Estrutural).
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Departamento Jurídico altamente especializado.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Os melhores e mais modernos Sistemas Operacionais à disposição. A Imobiliária Yara investe seriamente em tecnologia, de forma que nossos clientes tenham acesso às ferramentas mais eficazes do mercado.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i>
                Plataforma digital. Seu Condomínio em seu telefone. Simples, completo e na hora!
            </li>
        </ul>
        <hr>
		<p>Esclareça as dúvidas a respeito de seu Condomínio, mesmo que não seja nosso cliente. Teremos a honra de tentar ajudá-lo e, acaso seja de seu interesse conhecer melhor a Imobiliária, agende um horário, que o café é por nossa conta.</p>
		<div class="button mt-40 text-center">        
			<a href="/solicite-proposta" use:link replace title="" class="btn btn-secondary">
				Solicite uma proposta <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
			</a>
        </div>        

	</div>
</section>

<style type="text/sass">

.card-border
    padding: 20px
    display: flex
    align-items: center
    flex-direction: column
    h2
        font-size: 16px
    p 
        font-size: 12px
        line-height: 120%

</style>
